import * as React from 'react';

import ClearAllView from 'filter-clear-all.view';
import { removeAllEventFilters } from '../../redux-state/actions/calendar.actions';
import { ICalendarAppState } from '../../redux-state';
import { connect } from 'react-redux';
import { ICalendarAppText } from '../../custom/classes/calendar-text';


interface IFilterExternalProps {
}

interface StateToProps {
    text: ICalendarAppText;
}

interface DispatchToProps {
    removeAllFilters: () => void;
}

export type ClearAllProps = IFilterExternalProps & StateToProps & DispatchToProps;

export class ClearAllBase extends React.Component<ClearAllProps, null> {
    render() {
        return <ClearAllView {...this.props} />;
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IFilterExternalProps): StateToProps {
    return {
        text: state.calendarText
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        removeAllFilters: () => dispatch(removeAllEventFilters())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ClearAllBase);